export default "__VITE_ASSET__5d9cb6fb__"